export default "__VITE_ASSET__Do1HGFhd__"